import { isDesktop } from "../MediaQuery/desktop";

export const isIOS =
  /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

export const getAppStoreLogos = (logos) => {
  if (isIOS) return [logos[0]];
  return isDesktop() ? logos : [logos[1], logos[2]];
};

export const isTestEnv = () => {
  try {
    const hostname =
      (window && window.location && window.location.hostname) || "";
    const href = (window && window.location && window.location.href) || "";
    const haystack = `${hostname} ${href}`.toLowerCase();
    return (
      haystack.includes("test.shopeepay") || haystack.includes("localhost")
    );
  } catch (e) {
    return false;
  }
};

export const getEnvFromUrl = () => (isTestEnv() ? "test" : "live");
